import React from 'react';
import { StarIcon, ChevronLeftIcon, SearchIcon } from 'lucide-react';
interface SidebarModelsPanelProps {
  kitchenModels: any[];
  showModels: boolean;
  handleModelsBack: () => void;
  modelSearch: string;
  setModelSearch: (search: string) => void;
  filterKitchenModels: () => any[];
  toggleModelFavorite: (modelId: string, event: React.MouseEvent) => void;
  modelFavorites: string[];
  handleModelSelect: (model: any) => void;
  showOnlyModelFavorites: boolean;
  setShowOnlyModelFavorites: (show: boolean) => void;
  showOnlySelectedModels: boolean;
  setShowOnlySelectedModels: (show: boolean) => void;
}
export function SidebarModelsPanel({
  kitchenModels,
  showModels,
  handleModelsBack,
  modelSearch,
  setModelSearch,
  filterKitchenModels,
  toggleModelFavorite,
  modelFavorites,
  handleModelSelect,
  showOnlyModelFavorites,
  setShowOnlyModelFavorites,
  showOnlySelectedModels,
  setShowOnlySelectedModels
}: SidebarModelsPanelProps) {
  if (!showModels) return null;
  return <div className="flex-1 flex flex-col overflow-hidden" data-id="element-943">
      {/* Header with back button */}
      <div className="p-3 border-b border-gray-200 dark:border-darkbg-border" data-id="element-944">
        <div className="flex items-center mb-2" data-id="element-945">
          <button onClick={handleModelsBack} className="p-1.5 rounded-full hover:bg-gray-100 dark:hover:bg-darkbg-primary mr-2" data-id="element-946">
            <ChevronLeftIcon className="h-5 w-5 text-gray-600 dark:text-gray-400" data-id="element-947" />
          </button>
          <h3 className="text-base font-medium text-gray-700 dark:text-gray-300" data-id="element-948">
            Kitchen Models
          </h3>
        </div>
        {/* Search bar */}
        <div className="relative" data-id="element-949">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-950">
            <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-951" />
          </div>
          <input type="text" value={modelSearch} onChange={e => setModelSearch(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full pl-10 p-3 dark:bg-darkbg-primary dark:border-darkbg-border dark:text-white" placeholder="Search models..." data-id="element-952" />
        </div>
      </div>
      {/* Models Header */}
      <div className="p-3 border-b border-gray-200 dark:border-darkbg-border flex items-center justify-between" data-id="element-953">
        <h3 className="font-medium text-gray-700 dark:text-gray-300" data-id="element-954">
          Kitchen Models
        </h3>
      </div>
      {/* Models Grid */}
      <div className="flex-1 overflow-y-auto p-3" data-id="element-955">
        <div className="mb-3" data-id="element-956"></div>
        <div className="grid grid-cols-3 gap-2" data-id="element-957">
          {filterKitchenModels().map(model => {
          const isFavorite = modelFavorites.includes(model.id);
          return <div key={model.id} className="border border-gray-200 rounded-lg overflow-hidden bg-white dark:bg-darkbg-secondary dark:border-darkbg-border hover:shadow-md transition-shadow" onClick={() => handleModelSelect(model)} data-id="element-958">
                <div className="relative" data-id="element-959">
                  <div className="w-full h-20 flex items-center justify-center" data-id="element-960">
                    <img src={model.image} alt={model.name} className="w-16 h-16 rounded-full object-cover shadow-sm" data-id="element-961" />
                    <button className={`absolute top-2 right-2 p-1 rounded-full ${isFavorite ? 'text-yellow-500' : 'text-gray-400 hover:text-yellow-500 dark:text-gray-500 dark:hover:text-yellow-500'}`} onClick={e => toggleModelFavorite(model.id, e)} data-id="element-962">
                      <StarIcon className={`h-4 w-4 ${isFavorite ? 'fill-current' : ''}`} data-id="element-963" />
                    </button>
                  </div>
                </div>
                <div className="p-2" data-id="element-964">
                  <div className="text-xs font-medium text-gray-800 dark:text-gray-200 mb-1 line-clamp-2" data-id="element-965">
                    {model.name}
                  </div>
                  <div className="flex flex-col text-xs text-gray-500 dark:text-gray-400" data-id="element-966">
                    <span data-id="element-967">{model.category}</span>
                    {model.style && <span data-id="element-968">{model.style}</span>}
                    {model.feature && <span data-id="element-969">{model.feature}</span>}
                    {model.brand && <div className="text-xs font-semibold text-gray-600 dark:text-gray-300" data-id="element-970">
                        {model.brand}
                      </div>}
                  </div>
                </div>
              </div>;
        })}
        </div>
        {/* Show message if no models match the filter */}
        {filterKitchenModels().length === 0 && <div className="text-center py-8" data-id="element-971">
            <p className="text-base text-gray-500 dark:text-gray-400" data-id="element-972">
              No models match your search.
            </p>
            <button className="mt-3 text-sm text-blue-600 hover:text-blue-800 dark:text-accent-blue dark:hover:text-blue-400" onClick={() => setModelSearch('')} data-id="element-973">
              Clear search
            </button>
          </div>}
      </div>
    </div>;
}